<template>
    <div>

        <el-button type="primary"
                   @click="startTour"
                   :disabled="!tourAvailable">
            {{$t('splitSegmentsTour.tourName')}}
        </el-button>

        <el-tour v-model="tourStart"
                 :target-area-clickable="false">

            <el-tour-step :title="$t('splitSegmentsTour.popupTitle')"
                          :content-style="stepStyle">

                <div>{{$t('splitSegmentsTour.popupDescription')}}</div>

                <div class="img-button-container merge-button">
                    <span class="material-symbols-outlined">
                        expand
                    </span>
                </div>

                <div>{{hotkey}}</div>

            </el-tour-step>

            <el-tour-step :title="$t('splitSegmentsTour.imageStepTitle')"
                          :content-style="wideStepStyle">

                <img class="screenshot"
                     src="@/images/Tours/split-view-tour.png"
                     alt="split-view-tour.png" />

                <ol class="image-points">
                    <li v-for="(point, index) in imagePoints"
                        :key="index">
                        {{point}}
                    </li>
                </ol>

            </el-tour-step>

        </el-tour>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { shortcuts } from '@/utils/shortcuts';

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                hotkey: this.$t('splitSegmentsTour.hotkey', [shortcuts.split.win]),

                imagePoints: [
                    this.$t('splitSegmentsTour.sourceSegmentDescription'),
                    this.$t('splitSegmentsTour.resultSegmentsDescription'),
                    this.$t('splitSegmentsTour.saveMergeSplitDescription'),
                    this.$t('splitSegmentsTour.cancelMergeSplitDescription'),
                ],

                tourStart: false,
                stepStyle: { width: '500px' },
                wideStepStyle: { width: '1000px' },
            };
        },
        methods: {
            startTour() {
                this.tourStart = true;
            },
        }
    })
</script>

<style scoped>
    .merge-button {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .screenshot {
        max-width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .image-points {
        margin: 0;
        padding-left: 20px;
    }
</style>
